import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=97045c64"
import script from "./CatalogSearch.vue?vue&type=script&lang=ts"
export * from "./CatalogSearch.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CatalogSearch.vue?vue&type=style&index=0&id=97045c64&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports